import React, { Component } from "react";
import ImgLogo from "../Images/logo_bilapp.png";

const styles = {
    container: {
        width  :"100%",
        heigth : "2px"
    },
    divider : {
        borderRadius : "50%",
        background: "red",
        color: "red"
    }
}

export default class Divider extends Component {
  render() {
    return(
        <div style={styles.container}>
            <div style={styles.divider}></div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_Divider.js